import script from "./Collapse.vue?vue&type=script&lang=ts&setup=true"
export * from "./Collapse.vue?vue&type=script&lang=ts&setup=true"

import "./Collapse.vue?vue&type=style&index=0&id=ddd5d9ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddd5d9ce"]])

export default __exports__